import { Navigate, useLocation } from 'react-router-dom';
import AuthService from "./Components/auth/AuthService";
import React from "react";

const Auth = new AuthService();

const ProtectedRoute = ({children}) => {  
    const securityPinExists = localStorage.getItem("securityPin");
    const location = useLocation()

    if (location.pathname === "/pin" && securityPinExists) {
        return <Navigate to="/dashboard" />;
    }

    const isAuthenticated = Auth.loggedIn();
    return isAuthenticated ? children : <Navigate to="/" />;
}

export default ProtectedRoute;